module.exports = __webpack_public_path__ + "img/i-min.f88cf4f0.jpg";